"use strict";

/*
 * ROBA LUCA 17/10/2026 (docs/shop/theme-custom-code.md §112).
 * Aanpassingen aan Zeniths popup, telkens gemarkeerd met "ROBA LUCA":
 * - de trigger (vertraging, scroll, exit) start pas als de cookiekeuze
 *   gemaakt is, en de popup opent nooit over een open lade, menu, het
 *   looks-paneel of de cookiekeuze: hij wacht tot die dicht is;
 * - focus naar de popup, Tab blijft erin, na sluiten terug waar je was;
 * - <body> krijgt rl-popup-open zolang hij openstaat (de chat gaat dan
 *   weg, rl-custom.css §36);
 * - na het inschrijven via de popup opent hij meteen op de bevestiging
 *   of de foutmelding, en daarna komt de nieuwsbriefpopup niet meer;
 * - niet voor wie uit een Klaviyo-mail komt, niet in de pauze
 *   (sperperiode, data in de editor);
 * - de foto laadt pas kort voor de popup opent;
 * - PostHog krijgt rl_popup_getoond, rl_popup_gesloten en
 *   rl_popup_ingeschreven, enkel als PostHog geladen is (dus na
 *   toestemming).
 * Bijgewerkt 17/10/2026 (§114):
 * - het formulier gaat zonder herladen naar Shopify, met dezelfde
 *   velden en Shopify's eigen spamcontrole; de knop krijgt intussen de
 *   laadstand van Zeniths knoppen. Lukt dat niet zoals verwacht, dan
 *   gaat het formulier op de gewone manier (met herladen);
 * - PostHog: rl_popup_ingeschreven met zonder_herladen, rl_popup_fout
 *   en rl_popup_terugval (met de reden).
 * Origineel: _archive/theme-zenith-origineel/popup.js.2026-10-17-origineel
 */

document.addEventListener("DOMContentLoaded", function () {
  var adpPopup = {};

  (function () {
    var $this;

    adpPopup = {
      sPrevious: window.scrollY,
      sDirection: "down",

      /*
       * Initialize
       */
      init: function (e) {
        $this = adpPopup;

        $this.popupInit(e);

        // Init events.
        $this.events(e);
      },

      /*
       * Events
       */
      events: function (e) {
        // Custom Events
        document.addEventListener("click", function (event) {
          if (
            (event.target.closest(".popup") &&
              (event.target.closest(".popup-close") ||
                event.target.closest(".popup-overlay") ||
                event.target.closest(".popup-button"))) ||
            !event.target.closest(".popup")
          ) {
            $this.closePopup(event);
          }
          if (
            event.target.matches(".popup-accept") ||
            event.target.closest(".popup-accept")
          ) {
            $this.acceptPopup(event);
            $this.closePopup(event);
          }
          if (
            event.target.matches(".age-verification__popup-close") ||
            event.target.closest(".age-verification__popup-close")
          ) {
            $this.agePopup(event);
            $this.closePopup(event);
          }
          if (
            event.target.matches(".age-verification__button-no") ||
            event.target.closest(".age-verification__button-no")
          ) {
            $this.ageDeclined(event);
          }
        });

        // Checking this will cause popup to close when user presses key.
        document.addEventListener("keyup", function (event) {
          // Press ESC to Close.
          if (event.key === "Escape") {
            document
              .querySelectorAll('.popup-open[data-esc-close="true"]')
              .forEach(function (popup) {
                $this.closePopup(popup);
              });
          }

          // Press F4 to Close.
          if (event.key === "F4") {
            document
              .querySelectorAll('.popup-open[data-f4-close="true"]')
              .forEach(function (popup) {
                $this.closePopup(popup);
              });
          }
        });

        // Checking this will cause popup to close when user clicks on overlay.
        document.querySelectorAll(".popup-overlay").forEach((element) => {
          element.addEventListener("click", (event) => {
            if (
              element.previousElementSibling.matches(
                '.popup-open[data-overlay-close="true"]'
              )
            ) {
              $this.closePopup(element.previousElementSibling);
            }
          });
        });
      },

      /*
       * Init popup elements
       */
      popupInit: function (e) {
        // Set scroll direction.
        document.addEventListener("scroll", function () {
          let scrollCurrent = window.scrollY;
          if (scrollCurrent > $this.sPrevious) {
            $this.sDirection = "down";
          } else {
            $this.sDirection = "up";
          }
          $this.sPrevious = scrollCurrent;
        });

        // Open popup
        document.querySelectorAll(".popup").forEach(function (popup) {
          // Manual Launch.
          if ("manual" === popup.getAttribute("data-open-trigger")) {
            let selector = popup.getAttribute("data-open-manual-selector");
            if (selector) {
              const onTriggerClick = (event) => {
                event.preventDefault();
                if (
                  event.target.closest(".popup-close") ||
                  event.target.closest(".popup-overlay") ||
                  event.target.closest(".popup-button")
                ) {
                  popup.classList.remove("popup-already-opened");
                  $this.openPopup(popup);
                  if (event.target.classList.contains("popup")) {
                    $this.closePopup(selector);
                  }
                }
              };

              const triggerInteraction = (triggerElement) => {
                if (!triggerElement) return;
                triggerElement.addEventListener("click", onTriggerClick);

                const isClickableOverlay =
                  triggerElement.getAttribute("data-overlay-close") === "true";
                const overlay = triggerElement.nextElementSibling;
                if (
                  isClickableOverlay &&
                  overlay &&
                  overlay.classList.contains("popup-overlay")
                ) {
                  overlay.addEventListener("click", onTriggerClick);
                }
              };

              let triggerEl;

              if (selector.charAt(0) == "#") {
                triggerEl = document.getElementById(selector.slice(1));
              } else {
                triggerEl = document.querySelector(selector);
              }

              triggerInteraction(triggerEl);
            }
          }
          // ROBA LUCA: onthouden dat dit formulier verstuurd werd.
          $this.rlVolgFormulier(popup);
          // ROBA LUCA: net verstuurd? Dan meteen de bevestiging of de fout.
          if ($this.rlNaVersturen(popup)) {
            return;
          }
          // Checks whether a popup should be displayed or not.
          if (
            !$this.isAllowPopup(popup) &&
            !popup.classList.contains("age-verification")
          ) {
            return;
          }
          // ROBA LUCA: eerst de cookiekeuze, dan pas de trigger.
          $this.rlNaCookiekeuze(function () {
            $this.rlFotoKlaarzetten(popup, false);
            $this.openTriggerPopup(popup);
          });
        });
      },

      /*
       * Trigger open popup
       */
      openTriggerPopup: function (popup) {
        let trigger = popup.getAttribute("data-open-trigger");
        // Age Verification.
        if (trigger === "none") {
          let ageVerification = $this.getStorage(
            "popup-age-" + (popup.getAttribute("data-id") || 0)
          );
          if (!ageVerification || Shopify.designMode) {
            $this.openPopup(popup);
          }
        }
        // Accept Agreement.
        // If there is Accept button - look entry in local storage.
        // If there is entry in local storage - popup is not displayed and function stops.
        // If there is no entry - function continues with other triggers.
        const hasAcceptBtn = popup.querySelector(".popup-accept");
        if (hasAcceptBtn) {
          let accept = $this.getStorage(
            "popup-accept-" + (popup.getAttribute("data-id") || 0)
          );
          if (accept && !Shopify.designMode) {
            trigger = "accept";
            return;
          }
        }
        // Time Delay.
        if (trigger === "delay") {
          setTimeout(function () {
            $this.openPopup(popup);
          }, parseInt(popup.getAttribute("data-open-delay-number")) * 1000);
        }
        // Exit Intent.
        if (trigger === "exit") {
          var showExit = true;
          document.addEventListener("mousemove", function (event) {
            var scroll =
              window.pageYOffset || document.documentElement.scrollTop;
            if (event.pageY - scroll < 7 && showExit) {
              $this.openPopup(popup);
              showExit = false;
            }
          });
        }
        // Scroll Position.
        if (trigger === "scroll") {
          const pointScrollType = popup.getAttribute("data-open-scroll-type");
          const pointScrollPosition = Number(
            popup.getAttribute("data-open-scroll-position")
          );
          document.addEventListener("scroll", function () {
            if (pointScrollType === "px") {
              if (window.scrollY >= pointScrollPosition) {
                $this.openPopup(popup);
              }
            }
            if (pointScrollType === "%") {
              if ($this.getScrollPercent() >= pointScrollPosition) {
                $this.openPopup(popup);
              }
            }
          });
        }
      },

      /*
       * Trigger close popup
       */
      closeTriggerPopup: function (popup) {
        var trigger = popup.getAttribute("data-close-trigger");
        // Time Delay.
        if (trigger === "delay") {
          setTimeout(function () {
            $this.closePopup(popup);
          }, parseInt(popup.getAttribute("data-close-delay-number")) * 1000);
        }
        // Scroll Position.
        if (trigger === "scroll") {
          const pointScrollType = popup.getAttribute("data-close-scroll-type");
          const pointScrollPosition = Number(
            popup.getAttribute("data-close-scroll-position")
          );

          document.addEventListener("scroll", function () {
            if (pointScrollType === "px") {
              if (window.scrollY >= pointScrollPosition) {
                $this.closePopup(popup);
              }
            }

            if (pointScrollType === "%") {
              if ($this.getScrollPercent() >= pointScrollPosition) {
                $this.closePopup(popup);
              }
            }
          });
        }
      },

      /*
       * Open popup
       */
      openPopup: function (popup) {
        // Check already opened.
        if (popup.classList.contains("popup-already-opened")) {
          return;
        }
        if (popup.classList.contains("popup-open")) {
          return;
        }
        // ROBA LUCA: nooit over een open lade, menu, het looks-paneel of
        // de cookiekeuze. Wacht tot die dicht is, dan nog 1 seconde.
        if (
          popup.classList.contains("rl-popup") &&
          !Shopify.designMode &&
          $this.rlIetsOpen()
        ) {
          $this.rlWachtTotDicht(popup);
          return;
        }
        // Hide body scroll.
        if (popup.getAttribute("data-body-scroll-disable") === "true") {
          document.body.classList.add("popup-scroll-hidden");

          if (popup.getAttribute("data-mobile-disable") === "false") {
            document.body.classList.add("popup-scroll-hidden-mobile");
          }
        }

        const key = "popup-" + popup.getAttribute("data-id");
        const limit = parseInt($this.getStorage(key) || 0) + 1;
        $this.setStorage(key, limit, {
          expires: popup.getAttribute("data-limit-lifetime"),
        });

        // Display popup.
        popup.classList.add("popup-open");
        // Set current scroll.
        popup.setAttribute("data-init-scroll-px", window.scrollY);
        popup.setAttribute(
          "data-init-scroll-percent",
          $this.getScrollPercent()
        );
        // Open animation.
        let animation = popup.getAttribute("data-open-animation");
        $this.applyAnimation(popup, animation);
        // Init close trigger.
        $this.closeTriggerPopup(popup);

        // ROBA LUCA: dialoog voor toetsenbord en schermlezer, chat weg.
        if (popup.classList.contains("rl-popup")) {
          $this.rlOpen(popup);
        } else {
          popup.focus();
        }
      },

      /*
       * Age popup
       */
      agePopup: function (event) {
        let el = event.target ? event.target : event;

        // Get popup container.
        let popup = el.closest(".popup");
        $this.setStorage("popup-age-" + popup.getAttribute("data-id"), 1, {
          expires: 360,
        });
      },

      /*
       * Age declined
       */
      ageDeclined: function () {
        document
          .querySelectorAll(".age-verification__question")
          .forEach(function (el) {
            el.classList.remove("show");
          });
        document
          .querySelector(".age-verification__declined")
          ?.classList.add("show");

        // Remove all sections except age verification
        if (!window.Shopify.designMode) {
          document.querySelectorAll(".shopify-section").forEach((el) => {
            if (!el.classList.contains("age-verification-section")) {
              el.remove();
            }
          });
        }
      },

      /*
       * Accept popup
       */
      acceptPopup: function (event) {
        let el = event.target ? event.target : event;

        // Get popup container.
        let popup = el.closest(".popup");
        $this.setStorage("popup-accept-" + popup.getAttribute("data-id"), 1, {
          expires: 360,
        });
      },

      /*
       * Close popup
       */
      closePopup: function (event) {
        let el = event.target ? event.target : event;
        // Get popup container.
        let popup = el.closest(".popup");
        // ROBA LUCA: enkel bij een popup die echt openstaat.
        if (
          popup &&
          popup.classList.contains("rl-popup") &&
          popup.classList.contains("popup-open")
        ) {
          $this.rlDicht(popup);
        }
        // Close animation.
        let animation = popup?.getAttribute("data-exit-animation");
        $this.applyAnimation(popup, animation, function () {
          // Already opened.
          popup.classList.add("popup-already-opened");
          // Hide popup.
          popup.classList.remove("popup-open");

          popup.blur();
        });
        document.body.classList.remove("popup-scroll-hidden");
        document.body.classList.remove("popup-scroll-hidden-mobile");
      },

      /*
       * Checks whether a popup should be displayed or not
       */
      isAllowPopup: function (popup) {
        // ROBA LUCA: de nieuwsbriefpopup niet voor wie al ingeschreven is
        // of uit een Klaviyo-mail komt, en geen popup in de pauze.
        if (!Shopify.designMode) {
          if (
            popup.getAttribute("data-rl-nieuwsbrief") === "true" &&
            $this.rlIngeschreven()
          ) {
            return false;
          }
          if ($this.rlInPauze(popup)) {
            return false;
          }
        }
        // Has user seen this popup before?
        let limitDisplay = parseInt(
          popup.getAttribute("data-limit-display") || 0
        );
        let limitDisplayStored = parseInt(
          $this.getStorage("popup-" + popup.getAttribute("data-id"))
        );
        if (
          !Shopify.designMode &&
          limitDisplay &&
          limitDisplayStored &&
          limitDisplayStored >= limitDisplay
        ) {
          return false;
        }
        return true;
      },

      /*
       * Apply animation
       */
      applyAnimation: function (el, name, callback) {
        var popup = el?.closest(".popup");
        let overlayName;
        if (typeof callback === "function") {
          overlayName = "popupExitFade";
        } else {
          overlayName = "popupOpenFade";
        }
        // Overlay Animation.
        if (popup?.nextElementSibling) {
          popup.nextElementSibling.classList.add("popup-animated", overlayName);
          popup.nextElementSibling.addEventListener(
            "animationend",
            function () {
              this.classList.remove("popup-animated", overlayName);
            }
          );
        }
        // Wrap Animation.
        popup
          ?.querySelector(".popup-wrap")
          .classList.add("popup-animated", name);
        popup
          ?.querySelector(".popup-wrap")
          .addEventListener("animationend", function () {
            // remove the animation classes after animation ends
            // required in order to apply new animation on close
            this.classList.remove("popup-animated", name);
            if (typeof callback === "function") {
              callback();
            }
          });
      },

      /*
       * ROBA LUCA: wacht op de cookiekeuze van rl-consent.
       * rl-consent meldt rl:consent-klaar en opent daarna meteen de banner
       * als er nog gekozen moet worden. Staat de banner open, dan wachten
       * tot hij dicht is. Laadt rl-consent niet, dan na 10 s toch verder.
       */
      rlNaCookiekeuze: function (verder) {
        let gedaan = false;
        const eenmaal = function () {
          if (gedaan) return;
          gedaan = true;
          verder();
        };
        if (Shopify.designMode) return eenmaal();
        const banner = document.getElementById("RlConsent");
        if (!banner) return eenmaal();
        const naBanner = function () {
          if (!banner.hasAttribute("data-rl-open")) return eenmaal();
          const kijker = new MutationObserver(function () {
            if (banner.hasAttribute("data-rl-open")) return;
            kijker.disconnect();
            eenmaal();
          });
          kijker.observe(banner, {
            attributes: true,
            attributeFilter: ["data-rl-open"],
          });
        };
        if (window.rlConsentKlaar) return naBanner();
        document.addEventListener(
          "rl:consent-klaar",
          function () {
            window.setTimeout(naBanner, 0);
          },
          { once: true }
        );
        window.setTimeout(function () {
          if (!gedaan && !banner.hasAttribute("data-rl-open")) eenmaal();
        }, 10000);
      },

      /*
       * ROBA LUCA: staat er iets open? Zenith zet een klasse met
       * overflow-hidden op <body> voor lades, het menu en popups, rl-consent
       * doet dat ook, het looks-paneel zet rl-looks-lock.
       */
      rlIetsOpen: function () {
        const klassen = document.body.className;
        return (
          /overflow-hidden/.test(klassen) ||
          /(^|\s)rl-looks-lock(\s|$)/.test(klassen) ||
          !!document.querySelector("#RlConsent[data-rl-open]")
        );
      },

      rlWachtTotDicht: function (popup) {
        if (popup.rlWacht) return;
        const banner = document.getElementById("RlConsent");
        popup.rlWacht = new MutationObserver(function () {
          if ($this.rlIetsOpen()) return;
          popup.rlWacht.disconnect();
          popup.rlWacht = null;
          window.setTimeout(function () {
            $this.openPopup(popup);
          }, 1000);
        });
        popup.rlWacht.observe(document.body, {
          attributes: true,
          attributeFilter: ["class"],
        });
        if (banner) {
          popup.rlWacht.observe(banner, {
            attributes: true,
            attributeFilter: ["data-rl-open"],
          });
        }
      },

      /*
       * ROBA LUCA: bij het openen. De foto (als die nog niet geladen is),
       * de chat weg, focus in de dialoog. Bij een fout gaat de focus naar
       * het veld. Tab en Shift+Tab blijven in de popup. Een eigen lus en
       * niet trapFocus uit global.js: die telt ook knoppen mee die
       * verborgen zijn (de bevestiging), en dan glipt Tab eruit.
       */
      rlOpen: function (popup) {
        $this.rlFotoKlaarzetten(popup, true);
        popup.rlTerug = document.activeElement;
        if (popup.getAttribute("data-overlay") === "true") {
          document.body.classList.add("rl-popup-open");
        }
        const dialoog = popup.querySelector('[role="dialog"]');
        if (dialoog) {
          if (popup.rlTab) document.removeEventListener("keydown", popup.rlTab);
          popup.rlTab = function (event) {
            if (event.key !== "Tab") return;
            const zichtbaar = Array.from(
              dialoog.querySelectorAll(
                'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex^="-"])'
              )
            ).filter(function (el) {
              return el.getClientRects().length > 0;
            });
            if (!zichtbaar.length) {
              event.preventDefault();
              return;
            }
            const eerste = zichtbaar[0];
            const laatste = zichtbaar[zichtbaar.length - 1];
            const nu = document.activeElement;
            if (event.shiftKey) {
              if (nu === eerste || nu === dialoog || !dialoog.contains(nu)) {
                event.preventDefault();
                laatste.focus();
              }
            } else if (nu === laatste || !dialoog.contains(nu)) {
              event.preventDefault();
              eerste.focus();
            }
          };
          document.addEventListener("keydown", popup.rlTab);
          const doel =
            popup.querySelector('[aria-invalid="true"]') || dialoog;
          window.requestAnimationFrame(function () {
            doel.focus({ preventScroll: true });
          });
        }
        $this.rlMeet(
          popup.classList.contains("rl-popup--klaar")
            ? "rl_popup_bevestiging_getoond"
            : "rl_popup_getoond",
          popup
        );
      },

      rlDicht: function (popup) {
        document.body.classList.remove("rl-popup-open");
        if (popup.rlTab) {
          document.removeEventListener("keydown", popup.rlTab);
          popup.rlTab = null;
        }
        const terug = popup.rlTerug;
        if (terug && terug !== document.body && document.contains(terug)) {
          try {
            terug.focus({ preventScroll: true });
          } catch (e) {}
        }
        popup.rlTerug = null;
        // Na het inschrijven: terug naar waar de bezoeker op de pagina was.
        if (typeof popup.rlScroll === "number") {
          // instant: de pagina staat op scroll-behavior smooth, en dan zou
          // je de pagina zien terugschuiven.
          window.scrollTo({ top: popup.rlScroll, left: 0, behavior: "instant" });
          popup.rlScroll = null;
        }
        $this.rlMeet("rl_popup_gesloten", popup, {
          na_inschrijven: popup.classList.contains("rl-popup--klaar"),
        });
      },

      /*
       * ROBA LUCA: de foto zit in een verborgen popup en laadt lazy, dus
       * pas als de popup opengaat, en dan verschijnt hij even later. Bij
       * een vertraging laadt hij 4 s vóór het openen, anders 2 s na het
       * laden van de pagina. Nooit vroeger: dan concurreert hij met de
       * foto's van de pagina zelf.
       */
      rlFotoKlaarzetten: function (popup, nu) {
        if (!popup.classList.contains("rl-popup")) return;
        const foto = popup.querySelector(".popup-thumbnail img[loading='lazy']");
        if (!foto) return;
        const laad = function () {
          foto.loading = "eager";
        };
        if (nu) return laad();
        if (popup.getAttribute("data-open-trigger") === "delay") {
          const wacht =
            parseInt(popup.getAttribute("data-open-delay-number"), 10) * 1000 -
            4000;
          window.setTimeout(laad, Math.max(wacht, 0));
        } else if (document.readyState === "complete") {
          window.setTimeout(laad, 2000);
        } else {
          window.addEventListener(
            "load",
            function () {
              window.setTimeout(laad, 2000);
            },
            { once: true }
          );
        }
      },

      /*
       * ROBA LUCA (§112, bijgewerkt §114): het formulier versturen zonder
       * de pagina te herladen.
       *
       * Shopify's spamcontrole (hCaptcha, script storefront-forms-hcaptcha
       * v1.5.3, nagelezen op 17/10/2026) koppelt zich aan het formulier
       * zodra je erin tikt. Bij het versturen haalt ze een controlecode,
       * zet die in het formulier en roept dan de submit-functie op die het
       * formulier had op het moment van koppelen. Die functie vervangen we
       * hier, vóór dat koppelen, door rlVerstuur. Zo gaat het formulier na
       * de controle via fetch naar Shopify, met dezelfde velden en dezelfde
       * controlecode, en blijft de pagina staan. Is het formulier (nog)
       * niet gekoppeld, dan verstuurt rlVerstuur het meteen zelf.
       *
       * Lukt het niet zoals verwacht (Shopify vraagt een extra controle,
       * een onbekend antwoord, geen verbinding, langer dan 15 s), dan gaat
       * het formulier alsnog op de gewone manier, met herladen: er gaat
       * geen inschrijving verloren. Verandert Shopify zijn script, dan is
       * dat ook het ergste wat er gebeurt.
       *
       * Bij elke verzending onthoudt sessionStorage welke popup het was en
       * waar de bezoeker stond, voor als de pagina toch herlaadt. Shopify
       * toont na een herlading ook in de footer "Thanks for subscribing."
       * met autofocus, en de browser springt daarheen. De popup ligt er
       * dan over; bij het sluiten zetten we de pagina terug waar de
       * bezoeker was (rlNaVersturen en rlDicht).
       */
      rlVolgFormulier: function (popup) {
        const form = popup.querySelector('form[id^="popup_newsletter_"]');
        if (!form || form.rlGevolgd) return;
        form.rlGevolgd = true;
        try {
          form.submit = function () {
            $this.rlVerstuur(popup, form);
          };
        } catch (e) {}
        form.addEventListener("submit", function (event) {
          const knop = form.querySelector('button[type="submit"]');
          // Al bezig: een tweede tik doet niets, ook niet bij Shopify.
          if (knop && knop.classList.contains("loading")) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }
          $this.rlBewaarPlek(popup);
          $this.rlLaden(form, true);
          // Gekoppeld aan de spamcontrole: Shopify neemt het over en roept
          // na de controle form.submit op, dus rlVerstuur.
          if (form.hasAttribute("data-hcaptcha-bound")) return;
          event.preventDefault();
          $this.rlVerstuur(popup, form);
        });
        // Opnieuw typen haalt de foutmelding weg.
        const veld = form.querySelector('input[type="email"]');
        if (veld) {
          veld.addEventListener("input", function () {
            if (veld.getAttribute("aria-invalid") === "true") {
              $this.rlToonFout(popup, form, null);
            }
          });
        }
      },

      rlBewaarPlek: function (popup) {
        try {
          window.sessionStorage.setItem(
            "rl-popup-verstuurd",
            popup.getAttribute("data-id")
          );
          window.sessionStorage.setItem(
            "rl-popup-scroll",
            String(Math.round(window.scrollY))
          );
        } catch (e) {}
      },

      rlVergeetPlek: function () {
        try {
          window.sessionStorage.removeItem("rl-popup-verstuurd");
          window.sessionStorage.removeItem("rl-popup-scroll");
        } catch (e) {}
      },

      /*
       * ROBA LUCA (§114): de laadstand van Zeniths knoppen, zoals Add to
       * cart in global.js: .loading verbergt de tekst en het draaiende
       * icoon verschijnt. Komt er 10 s niets (de spamcontrole geraakt niet
       * rond, bv. de bezoeker sluit de puzzel van hCaptcha), dan terug naar
       * normaal, zodat de bezoeker opnieuw kan proberen. Komt de
       * controlecode later toch, dan start rlVerstuur de laadstand opnieuw.
       */
      rlLaden: function (form, aan) {
        const knop = form.querySelector('button[type="submit"]');
        if (!knop) return;
        const icoon = knop.querySelector(".loading-overlay__spinner");
        window.clearTimeout(form.rlWaakhond);
        if (aan) {
          knop.classList.add("loading");
          knop.setAttribute("aria-disabled", "true");
          form.setAttribute("aria-busy", "true");
          if (icoon) icoon.classList.remove("hidden");
          form.rlWaakhond = window.setTimeout(function () {
            if (!form.rlBezig && !form.rlGewoon) $this.rlLaden(form, false);
          }, 10000);
        } else {
          knop.classList.remove("loading");
          knop.removeAttribute("aria-disabled");
          form.removeAttribute("aria-busy");
          if (icoon) icoon.classList.add("hidden");
        }
      },

      /*
       * ROBA LUCA (§114): het formulier zelf naar Shopify sturen en het
       * antwoord lezen. Shopify stuurt na een geslaagde inschrijving door
       * naar de pagina met ?customer_posted=true; fetch volgt dat. Een fout
       * (bv. een ongeldig adres) staat in de pagina die terugkomt, in het
       * foutvak van dit formulier.
       */
      rlVerstuur: function (popup, form) {
        if (form.rlGewoon) {
          HTMLFormElement.prototype.submit.call(form);
          return;
        }
        if (form.rlBezig) return;
        if (!window.fetch || !window.FormData || !window.DOMParser) {
          $this.rlTerugval(popup, form, "oude_browser");
          return;
        }
        form.rlBezig = true;
        $this.rlLaden(form, true);
        $this.rlToonFout(popup, form, null);
        const regelaar = window.AbortController ? new AbortController() : null;
        const klok = window.setTimeout(function () {
          if (regelaar) regelaar.abort();
        }, 15000);
        const adres = (form.getAttribute("action") || "/contact").split("#")[0];
        window
          .fetch(adres, {
            method: "POST",
            body: new FormData(form),
            credentials: "same-origin",
            headers: { Accept: "text/html" },
            signal: regelaar ? regelaar.signal : undefined,
          })
          .then(function (antwoord) {
            const url = antwoord.url || "";
            if (/[?&]customer_posted=true/.test(url)) {
              try {
                antwoord.body.cancel();
              } catch (e) {}
              return { gelukt: true };
            }
            if (url.indexOf("/challenge") !== -1) return { terug: "controle" };
            if (!antwoord.ok) return { terug: "status_" + antwoord.status };
            return antwoord.text().then(function (html) {
              const doc = new DOMParser().parseFromString(html, "text/html");
              const terug = doc.getElementById(form.id);
              if (terug) {
                if (terug.querySelector("[data-rl-popup-gelukt]")) {
                  return { gelukt: true };
                }
                const fout = terug.querySelector(
                  ".rl-popup__fout:not([hidden]) .rl-popup__fout-tekst"
                );
                const tekst = fout
                  ? fout.textContent.replace(/\s+/g, " ").trim()
                  : "";
                if (tekst) return { fout: tekst };
              }
              return { terug: "onbekend" };
            });
          })
          .catch(function () {
            return {
              terug:
                regelaar && regelaar.signal.aborted ? "te_traag" : "netwerk",
            };
          })
          .then(function (uitkomst) {
            window.clearTimeout(klok);
            form.rlBezig = false;
            if (uitkomst.gelukt) {
              $this.rlGelukt(popup, form);
            } else if (uitkomst.fout) {
              $this.rlLaden(form, false);
              $this.rlToonFout(popup, form, uitkomst.fout);
              $this.rlMeet("rl_popup_fout", popup, { zonder_herladen: true });
            } else {
              $this.rlTerugval(popup, form, uitkomst.terug);
            }
          })
          .catch(function () {});
      },

      rlGelukt: function (popup, form) {
        $this.rlLaden(form, false);
        $this.rlVergeetPlek();
        // ROBA LUCA (§115): Klaviyo meteen laten weten (rl-custom.js).
        try {
          document.dispatchEvent(new CustomEvent("rl:nieuwsbrief-ingeschreven"));
        } catch (e) {}
        try {
          $this.setStorage("rl-nieuwsbrief", 1);
        } catch (e) {}
        $this.rlKlaar(popup);
        $this.rlMeet("rl_popup_ingeschreven", popup, { zonder_herladen: true });
        if (!popup.classList.contains("popup-open")) return;
        $this.rlMeet("rl_popup_bevestiging_getoond", popup);
        const titel = popup.querySelector(".rl-popup__klaar-titel");
        if (titel) {
          titel.setAttribute("tabindex", "-1");
          window.requestAnimationFrame(function () {
            titel.focus({ preventScroll: true });
          });
        }
      },

      rlKlaar: function (popup) {
        popup.classList.add("rl-popup--klaar");
        const klaar = popup.querySelector(".rl-popup__klaar-titel");
        const dialoog = popup.querySelector('[role="dialog"]');
        if (klaar && dialoog) {
          dialoog.setAttribute("aria-labelledby", klaar.id);
        }
      },

      rlToonFout: function (popup, form, tekst) {
        const vak = form.querySelector(".rl-popup__fout");
        const veld = form.querySelector('input[type="email"]');
        if (!vak) return;
        const plek = vak.querySelector(".rl-popup__fout-tekst") || vak;
        if (!tekst) {
          if (!vak.hidden) {
            vak.hidden = true;
            plek.textContent = "";
          }
          if (veld) {
            veld.removeAttribute("aria-invalid");
            if (veld.getAttribute("aria-describedby") === vak.id) {
              veld.removeAttribute("aria-describedby");
            }
          }
          return;
        }
        plek.textContent = tekst;
        vak.hidden = false;
        if (veld) {
          veld.setAttribute("aria-invalid", "true");
          veld.setAttribute("aria-describedby", vak.id);
          veld.focus({ preventScroll: true });
        }
      },

      /*
       * ROBA LUCA (§114): terug naar de gewone verzending, met herladen.
       * HTMLFormElement.prototype.submit, want form.submit is intussen
       * rlVerstuur of de functie van Shopify's spamcontrole.
       */
      rlTerugval: function (popup, form, reden) {
        $this.rlMeet("rl_popup_terugval", popup, { reden: reden });
        $this.rlBewaarPlek(popup);
        form.rlGewoon = true;
        $this.rlLaden(form, true);
        HTMLFormElement.prototype.submit.call(form);
      },

      rlNaVersturen: function (popup) {
        if (!popup.classList.contains("rl-popup")) return false;
        const form = popup.querySelector('form[id^="popup_newsletter_"]');
        if (!form) return false;
        let verstuurd = null;
        let scroll = null;
        try {
          verstuurd = window.sessionStorage.getItem("rl-popup-verstuurd");
          scroll = window.sessionStorage.getItem("rl-popup-scroll");
        } catch (e) {}
        const viaAnker = window.location.hash === "#" + form.id;
        if (verstuurd !== popup.getAttribute("data-id") && !viaAnker) {
          return false;
        }
        $this.rlVergeetPlek();
        if (scroll !== null && !isNaN(parseInt(scroll, 10))) {
          popup.rlScroll = parseInt(scroll, 10);
        }
        const gelukt = !!popup.querySelector("[data-rl-popup-gelukt]");
        // Het foutvak staat er altijd (§114); enkel zichtbaar bij een fout.
        const fout = !!popup.querySelector(".rl-popup__fout:not([hidden])");
        if (!gelukt && !fout) return false;
        if (gelukt) {
          $this.setStorage("rl-nieuwsbrief", 1);
          $this.rlKlaar(popup);
          $this.rlMeet("rl_popup_ingeschreven", popup, {
            zonder_herladen: false,
          });
        }
        // Het anker en customer_posted uit de adresbalk, anders toont de
        // pagina dit opnieuw bij herladen. Het vinkje "ingeschreven" staat
        // al (hierboven, of via rlIngeschreven bij een fout).
        if (window.history && window.history.replaceState) {
          const zoek = window.location.search
            .replace(/([?&])customer_posted=true(&|$)/, function (m, voor, na) {
              return na ? voor : "";
            });
          window.history.replaceState(
            null,
            "",
            window.location.pathname + zoek
          );
        }
        popup.classList.remove("popup-already-opened");
        $this.openPopup(popup);
        return true;
      },

      /*
       * ROBA LUCA: al ingeschreven? Onthouden na een geslaagde inschrijving
       * (ook via de footer: Shopify zet dan customer_posted=true in het
       * adres) en voor wie uit een Klaviyo-mail komt: die staat al op de
       * lijst of heeft al besteld, en de welkomstcode is enkel voor een
       * eerste bestelling. Zonder vervaldatum.
       */
      rlIngeschreven: function () {
        try {
          const zoek = new URLSearchParams(window.location.search);
          const bron = (zoek.get("utm_source") || "").toLowerCase();
          const medium = (zoek.get("utm_medium") || "").toLowerCase();
          if (
            bron === "klaviyo" ||
            medium === "email" ||
            zoek.get("customer_posted") === "true"
          ) {
            $this.setStorage("rl-nieuwsbrief", 1);
          }
        } catch (e) {}
        return !!$this.getStorage("rl-nieuwsbrief");
      },

      /*
       * ROBA LUCA: pauze, bv. de sperperiode. Van de eerste dag tot de
       * dag waarop hij weer aan mag (die dag zelf niet meer), Belgische
       * tijd, als JJJJ-MM-DD uit de editor.
       */
      rlInPauze: function (popup) {
        const van = popup.getAttribute("data-rl-pauze-van");
        const tot = popup.getAttribute("data-rl-pauze-tot");
        const vorm = /^\d{4}-\d{2}-\d{2}$/;
        if (!van || !tot || !vorm.test(van) || !vorm.test(tot)) return false;
        let vandaag;
        try {
          const delen = {};
          new Intl.DateTimeFormat("en-GB", {
            timeZone: "Europe/Brussels",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })
            .formatToParts(new Date())
            .forEach(function (deel) {
              delen[deel.type] = deel.value;
            });
          vandaag = delen.year + "-" + delen.month + "-" + delen.day;
        } catch (e) {
          vandaag = new Date().toISOString().slice(0, 10);
        }
        return vandaag >= van && vandaag < tot;
      },

      /*
       * ROBA LUCA: meten in PostHog, enkel als PostHog echt geladen is.
       * rl-posthog.liquid laadt het pas na toestemming voor analytics.
       */
      rlMeet: function (naam, popup, extra) {
        try {
          const ph = window.posthog;
          if (!ph || !ph.__loaded || typeof ph.capture !== "function") return;
          const data = { popup: popup.getAttribute("data-id") };
          if (extra) {
            Object.keys(extra).forEach(function (sleutel) {
              data[sleutel] = extra[sleutel];
            });
          }
          ph.capture(naam, data);
        } catch (e) {}
      },

      /*
       * Get local storage
       */
      getStorage: function (key) {
        const item = localStorage.getItem(key);
        if (!item) return undefined;

        try {
          const parsed = JSON.parse(item);
          if (parsed.expires && Date.now() > parsed.expires) {
            localStorage.removeItem(key);
            return undefined;
          }
          return parsed.value;
        } catch {
          return undefined;
        }
      },

      /*
       * Set local storage
       */
      setStorage: function (key, value, options = {}) {
        const data = {
          value,
          expires: null,
        };
        if (options.expires) {
          const expiresDate = new Date();
          expiresDate.setDate(
            expiresDate.getDate() + parseInt(options.expires, 10)
          );
          data.expires = expiresDate.getTime();
        }
        localStorage.setItem(key, JSON.stringify(data));
      },

      /*
       * Get scroll percent
       */
      getScrollPercent: function () {
        const h = document.documentElement,
          b = document.body,
          st = "scrollTop",
          sh = "scrollHeight";
        return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
      },
    };
  })();

  // Initialize.
  adpPopup.init();

  document.addEventListener("shopify:section:load", function () {
    adpPopup.init();
  });

  document.addEventListener("shopify:section:unload", function () {
    document.body.classList.remove("popup-scroll-hidden");
  });
});
